<template>
    <div id="TituloPagina">
        <div class="container no-margin no-padding">
            <div class="row">
                <div class="col s10 m6 l6">
                 <h4 class="header">{{ titulo }}</h4>
                   <!-- <h5 class="breadcrumbs-title">{{ titulo }}</h5>-->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: () => ({}),
        props: {
            titulo: {
                type: String,
                required: true
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/common/TituloPagina.vue